"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _styles = require("@material-ui/core/styles");
var _excluded = ["children", "dataMetrics"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    captionRoot: {
      letterSpacing: '0px',
      lineHeight: '14px'
    }
  };
});
var defaultProps = {
  align: 'inherit',
  color: 'initial',
  dataMetrics: {
    root: 'fuse_typography'
  },
  display: 'initial',
  gutterBottom: false,
  noWrap: false,
  paragraph: false,
  variant: 'body1'
};
var Typography = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var children = _ref.children,
    dataMetrics = _ref.dataMetrics,
    restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classes = useStyles();
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  return /*#__PURE__*/_react["default"].createElement(_Typography["default"], (0, _extends2["default"])({
    classes: {
      caption: classes.captionRoot
    },
    "data-metrics": mergedDataMetrics.root,
    ref: ref
  }, restProps), children);
});
Typography.defaultProps = defaultProps;
Typography.displayName = 'Typography';
Typography.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Set the text-align on the component.
   */
  align: _propTypes["default"].oneOf(['inherit', 'left', 'center', 'right', 'justify']),
  /**
   * The content of the component.
   */
  children: _propTypes["default"].node,
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes["default"].oneOf(['error', 'inherit', 'initial', 'primary', 'secondary', 'textPrimary', 'textSecondary']),
  /**
   *  **IMPORTANT FOR ACCESSIBILITY**. The component tag for proper semantics.  ex: component="h2".  This allows the styles of whatever variant you are using to be applied to the correct html tag.
   */
  component: _propTypes["default"].elementType,
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string
  }),
  /**
   * Controls the display type
   */
  display: _propTypes["default"].oneOf(['initial', 'block', 'inline']),
  /**
   * If `true`, the text will have a '0.35em' bottom margin .
   */
  gutterBottom: _propTypes["default"].bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with an ellipsis.
   */
  noWrap: _propTypes["default"].bool,
  /**
   * If `true`, the text will have a '16px' bottom margin.
   */
  paragraph: _propTypes["default"].bool,
  /**
   * Applies the theme typography styles.
   */
  variant: _propTypes["default"].oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline', 'srOnly', 'inherit'])
} : {};
var _default = Typography;
exports["default"] = _default;